// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__3X09R","option":"styles_option__KsD5-","iconContainer":"styles_iconContainer__3bPAS","typeContainer":"styles_typeContainer__ouvKq"};